import { createReducer, on } from '@ngrx/store';
import * as fromDirectDebitValidation from '../actions/direct.debit.validation.action';
import { StateSlice } from '@core/helpers/state-slice';
import { DirectDebitValidationResponse } from '@dgx-pr-spa/shared/util';

export type DirectDebitValidationState =
  StateSlice<DirectDebitValidationResponse>;

export const initialState: DirectDebitValidationState = {
  data: {} as DirectDebitValidationResponse,
  loaded: false,
  loading: false,
  error: null,
};

const directDebitReducer = createReducer(
  initialState,
  on(fromDirectDebitValidation.loadDirectDebitValidation, () => ({
    ...initialState,
    loading: true,
    loaded: false,
    error: null,
  })),
  on(
    fromDirectDebitValidation.loadDirectDebitValidationSuccess,
    (state, { payload }) => {
      return {
        ...state,
        data: payload,
        loading: false,
        loaded: true,
      };
    }
  ),
  on(
    fromDirectDebitValidation.loadDirectDebitValidationFail,
    (_, { payload }) => {
      return {
        ...initialState,
        data: {
          isValid: true,
        },
        error: payload,
      };
    }
  ),

  on(fromDirectDebitValidation.resetDirectDebitValidation, () => ({
    ...initialState,
  }))
);

export function reducer(
  state: DirectDebitValidationState | undefined,
  action: fromDirectDebitValidation.DirectDebitValidationActions
) {
  return directDebitReducer(state, action);
}
